'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function footerOtherLink(props) {
    var _useTranslation = (0, _reactI18next.useTranslation)('footer'),
        t = _useTranslation.t;

    var otherLink = function otherLink() {
        return !(0, _lodash.isEmpty)(t("otherLinks", { returnObjects: true })) && (0, _lodash.isArray)(t("otherLinks", { returnObjects: true })) && t("otherLinks", { returnObjects: true }).map(function (obj, key) {
            return _react2.default.createElement(
                'li',
                { key: key, className: 'float-left float-lg-none' },
                _react2.default.createElement(
                    'a',
                    {
                        className: 'foot-link',
                        href: props.returnFullURL(obj.url),
                        style: { cursor: 'pointer' },
                        key: key,
                        target: "_blank",
                        onClick: function onClick(e) {
                            e.preventDefault();
                            props.onURLClick(obj.url, 'footerRightSection');
                        }
                    },
                    obj.title
                )
            );
        });
    };

    return _react2.default.createElement(
        'div',
        { className: 'col-12 col-lg-2 otherLink' },
        _react2.default.createElement(
            'ul',
            null,
            otherLink()
        )
    );
}

exports.default = footerOtherLink;